<template>
  <span class="inline-block ml-2" v-tooltip="tooltip">
    <font-awesome-icon
      class="first:last:mx-0 text-lg"
      :icon="['fas', 'circle-question']"
    />
  </span>
</template>

<script>
export default {
  props: {
    tooltip: String
  },
  methods: {
  }
}
</script>
